(function () {
    const translations = {
        en: {
            minQty: 'Quantity',
            discount: 'Discount',
            buy: 'Buy {qty} +',
            off: '{discount}% Off'
        },
        nl: {
            minQty: 'Hoeveelheid',
            discount: 'Korting',
            buy: 'Koop {qty} +',
            off: '{discount}% korting'
        },
        de: {
            minQty: 'Menge',
            discount: 'Rabatt',
            buy: 'Kaufen Sie {qty} +',
            off: '{discount}% Rabatt'
        },
        fr: {
            minQty: 'Quantité',
            discount: 'Remise',
            buy: 'Achetez {qty} +',
            off: '{discount}% de réduction'
        },
        it: {
            minQty: 'Quantità',
            discount: 'Sconto',
            buy: 'Acquista {qty} +',
            off: '{discount}% di sconto'
        },
        sv: {
            minQty: 'Antal',
            discount: 'Rabatt',
            buy: 'Köp {qty} +',
            off: '{discount}% rabatt'
        }
    };

    function getCurrentLanguage() {
        let lang = (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : null;
        if (!lang) {
            const urlParams = new URLSearchParams(window.location.search);
            lang = urlParams.get('locale') || 'en';
        }
        if (!translations[lang]) lang = 'en';
        return lang;
    }

    function translateHulkWidget() {
        const lang = getCurrentLanguage();
        const t = translations[lang];

        const table = document.querySelector('.hulkapps-table');
        if (!table) return;

        const headers = table.querySelectorAll('thead th');
        if (headers.length >= 2) {
            headers[0].textContent = t.minQty;
            headers[1].textContent = t.discount;
        }

        const rows = table.querySelectorAll('tbody tr');
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            if (cells.length >= 2) {
                const qtyMatch = cells[0].textContent.match(/(\d+)/);
                if (qtyMatch) {
                    const qty = qtyMatch[1];
                    const span = cells[0].querySelector('.hulk-offer-text');
                    cells[0].childNodes[0].nodeValue = t.buy.replace('{qty}', qty) + ' ';
                }

                const priceSpan = cells[1].querySelector('.hulkapps-price');
                if (priceSpan) {
                    const discMatch = priceSpan.textContent.match(/(\d+)/);
                    if (discMatch) {
                        const discount = discMatch[1];
                        priceSpan.textContent = t.off.replace('{discount}', discount);
                    }
                }
            }
        });
    }

    function injectCompanyAccountBlock() {
    const table = document.querySelector('.hulkapps-table');
    const accountBlock = document.querySelector('.create-company-account');
    
    if (table && accountBlock && !accountBlock.dataset.injected) {
        // Hulk app is zichtbaar - toon en verplaats het block
        const hulkContainer = table.closest('.hulkapps-volume-discount') || table.parentElement;
        hulkContainer.insertAdjacentElement('afterend', accountBlock);
        accountBlock.dataset.injected = 'true';
        accountBlock.style.display = 'block';
    }
}


    const observer = new MutationObserver((mutations, obs) => {
        const table = document.querySelector('.hulkapps-table');
        if (table) {
            translateHulkWidget();
            injectCompanyAccountBlock();
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    setTimeout(() => {
        translateHulkWidget();
        injectCompanyAccountBlock();
    }, 2000);
    
    // Extra check na langere tijd voor het geval Hulk app niet laadt
    setTimeout(() => {
        injectCompanyAccountBlock();
        observer.disconnect();
    }, 5000);
})();
